<script setup lang="ts">
import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const role = defineModel()
</script>

<template>
  <div class="btn-group" role="group">
    <input
      v-model="role"
      type="radio"
      class="btn-check"
      name="role"
      id="admin"
      value="admin"
      autocomplete="off"
    />
    <label class="btn btn-outline-primary" for="admin">{{ t('role.admin') }}</label>

    <input
      v-model="role"
      type="radio"
      class="btn-check"
      name="role"
      value="member"
      id="member"
      autocomplete="off"
    />
    <label class="btn btn-outline-primary" for="member">{{ t('role.member') }}</label>
  </div>
</template>
